import http from '@/api/request'

// 教师信息分页
export function teacherPage (data = {}) {
  return http().post('/base/api/teacher/page', data)
}

// 教师信息查看
export function teacherView (id) {
  return http().get(`/base/api/teacher/view?id=${id}`)
}

// 教师课程查询
export function teacherCoursePage (data = {}) {
  return http().post('/resource/api/course/page', data)
}

// 教师等级
export function teacherRankList (data = {}) {
  return http().post('/base/api/teacher/rank/list', data)
}

// 教师信息搜索
export function teacherSearch (data = {}) {
  return http().post('/base/api/teacher/search', data)
}

